import { UrlFilterSchema } from "@core/hooks"

/**
 * URL filter schemas for the adv2 list pages. Shared between the filter form
 * (which writes the values) and the table (which reads them for the query) so
 * the URL stays the single source of truth.
 */

export const ORDER_FILTER_SCHEMA = {
  statuses: "numberArray",
  agent_types: "numberArray",
  agents: "numberArray",
  campaigns: "numberArray",
  types: "numberArray",
  referral_codes: "numberArray",
  geos: "numberArray",
  bots: "numberArray",
} as const satisfies UrlFilterSchema

export const PAYMENT_FILTER_SCHEMA = {
  agents: "numberArray",
  agent_types: "numberArray",
  geos: "numberArray",
  campaigns: "numberArray",
  order_types: "numberArray",
} as const satisfies UrlFilterSchema

export const AGENT_FILTER_SCHEMA = {
  agents: "numberArray",
  contacts: "numberArray",
  agent_types: "numberArray",
  geos: "numberArray",
} as const satisfies UrlFilterSchema
